module.exports = __webpack_public_path__ + "img/arrow_left.f9750f95.png";